import React from 'react'
import {
  HelpCircle,
  AlertCircle,
  CheckCircle2
} from 'lucide-react'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'

const MitosYRealidadesCard = ({ mitosYRealidades }) => {
  if (!mitosYRealidades) return null

  const { mitos } = mitosYRealidades

  return (
    <Card className="overflow-hidden bg-white">
      {/* Card Header */}
      <CardHeader className="border-b bg-gradient-to-r from-pink-500/10 to-transparent p-4 sm:p-5">
        <div className="flex items-center gap-3">
          <div className="p-2.5 bg-gradient-to-br from-pink-500 to-pink-600 rounded-lg shadow-sm">
            <HelpCircle className="h-5 w-5 sm:h-6 sm:w-6 text-white" />
          </div>
          <div>
            <CardTitle className="text-xl sm:text-2xl font-semibold text-gray-800">
              Mitos y Realidades
            </CardTitle>
            <p className="text-base text-gray-500 mt-1">
              Desmontando falsos conceptos y conociendo la verdad
            </p>
          </div>
        </div>
      </CardHeader>

      {/* Card Content */}
      <CardContent className="p-4 sm:p-5 space-y-4">
        {mitos?.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {mitos.map((item, idx) => (
              <div
                key={idx}
                className="bg-gradient-to-br from-pink-50 to-white rounded-lg border border-pink-100 p-4 hover:shadow-md transition-shadow space-y-3"
              >
                {/* Mito */}
                <div className="flex items-start gap-2">
                  <AlertCircle className="h-5 w-5 text-pink-500 mt-0.5 flex-shrink-0" />
                  <div className="space-y-1">
                    <p className="text-sm sm:text-base font-medium text-pink-600">Mito</p>
                    <p className="text-base text-gray-700 leading-relaxed">
                      {item.mito}
                    </p>
                  </div>
                </div>

                {/* Realidad */}
                <div className="flex items-start gap-2 bg-white p-3 rounded-lg border border-pink-50 hover:border-pink-200 transition-colors">
                  <CheckCircle2 className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                  <div className="space-y-1">
                    <p className="text-sm sm:text-base font-medium text-green-600">
                      Realidad
                    </p>
                    <p className="text-base text-gray-700 leading-relaxed">
                      {item.realidad}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  )
}

export default MitosYRealidadesCard
